import axios from "axios";

// export const SERVER_URL = "https://api.wisercam.com";
export const SERVER_URL = "https://apiv2.wisercam.com";
// export const SERVER_URL = "http://127.0.0.1:8000";

// const SERVER_URL = "http://192.168.1.21:8000";

// @route POST http://127.0.0.1:8000/accounts/login_or_register/
export const userAuthentication = (user) => {
  const url = `${SERVER_URL}/accounts/login_or_register/`;
  return axios.post(url, user);
};

export const createCompany = (information, token) => {
  const url = `${SERVER_URL}/accounts/companies/`;
  return axios.post(url, information, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCompany = (token) => {
  const url = `${SERVER_URL}/accounts/companies/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSingleCompany = (token, id) => {
  const url = `${SERVER_URL}/accounts/company/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editCompany = (token, data, id) => {
  const url = `${SERVER_URL}/accounts/company/${id}/`;
  return axios.patch(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteCompany = (token, id) => {
  const url = `${SERVER_URL}/accounts/company/${id}/`;
  return axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTicketMessages = (token, id) => {
  const url = `${SERVER_URL}/ticket/ticket/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAddresses = (token) => {
  const url = `${SERVER_URL}/accounts/addresses/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createAddress = (information, token) => {
  const url = `${SERVER_URL}/accounts/addresses/`;
  return axios.post(url, information, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editAddrress = (value, token, id) => {
  const url = `${SERVER_URL}/accounts/address/${id}/`;
  return axios.patch(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteAddrress = (token, id) => {
  const url = `${SERVER_URL}/accounts/address/${id}/`;
  return axios.delete(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSingleAddress = (token, id) => {
  const url = `${SERVER_URL}/accounts/address/${id}/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateProfile = (information, token) => {
  const url = `${SERVER_URL}/accounts/user/profile/update/`;
  return axios.patch(url, information, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://127.0.0.1:8000/accounts/register/
export const register = (user) => {
  const url = `${SERVER_URL}/accounts/register/`;
  return axios.post(url, user);
};

// @route POST http://127.0.0.1:8000/accounts/login/
export const login = (user) => {
  const url = `${SERVER_URL}/accounts/login/`;
  return axios.post(url, user);
};

// @route POST http://127.0.0.1:8000/accounts/otp/
export const otp = (user) => {
  const url = `${SERVER_URL}/accounts/otp/`;
  return axios.post(url, user);
};

// @route POST http://127.0.0.1:8000/accounts/login/otp/
export const loginOtp = (user) => {
  const url = `${SERVER_URL}/accounts/login/otp/`;
  return axios.post(url, user);
};

// @route POST http://127.0.0.1:8000/accounts/forgot_password/
export const forgotPassword = (user) => {
  const url = `${SERVER_URL}/accounts/forgot_password/`;
  return axios.post(url, user);
};

// @route POST http://127.0.0.1:8000/accounts/send_otp/
export const phoneNumberOtp = (data, token) => {
  const url = `${SERVER_URL}/accounts/send_otp/`;
  return axios.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://127.0.0.1:8000/accounts/otp_verify/
export const verifyPhoneNumber = (data) => {
  const url = `${SERVER_URL}/accounts/otp_verify/`;
  return axios.post(url, data);
};

// @route POST http://127.0.0.1:8000/accounts/auth_otp/
export const verifyUserNewPhoneNumber = (data, token) => {
  const url = `${SERVER_URL}/accounts/auth_otp/`;
  return axios.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://127.0.0.1:8000/accounts/send_email/
export const emailOtp = (data, token) => {
  const url = `${SERVER_URL}/accounts/send_email/`;
  return axios.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://127.0.0.1:8000/accounts/verify_email/
export const verifyEmail = (data, token) => {
  const url = `${SERVER_URL}/accounts/verify_email/`;
  return axios.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @desc  Create New service
// @route POST http://192.168.1.21:8000/shop/service/
export const createService = (portfolio, token) => {
  const url = `${SERVER_URL}/shop/service/`;
  return axios.post(url, portfolio, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/shop/service/
export const getServiceList = (token) => {
  const url = `${SERVER_URL}/shop/service/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/shop/services/file/
export const getServiceFileList = (token) => {
  const url = `${SERVER_URL}/shop/services/file/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/id/
export const deletService = (token, id) => {
  const url = `${SERVER_URL}/shop/service/${id}/`;
  return axios.delete(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const checkServiceExistsInOneOrder = (token, service_code) => {
  const url = `${SERVER_URL}/shop/exists_service_in_an_order/${service_code}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://94.183.187.36:8000/shop/services/delete/
export const manyDeletService = (value, token) => {
  const url = `${SERVER_URL}/shop/services/delete/`;
  return axios.post(url, value, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/8541253250/re_pricing/
export const repriceService = (token, id, writeMode = "repricing") => {
  const url = `${SERVER_URL}/shop/service/${id}/re_pricing/?mode=${writeMode}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/8541253250/prices/
export const priceService = (token, id) => {
  const url = `${SERVER_URL}/shop/service/${id}/prices/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route PUT http://192.168.1.21:8000/shop/service/repricing/
export const retrieveServicePut = (token, value) => {
  const url = `${SERVER_URL}/shop/service/update_price/`;
  return axios.put(url, value, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route POST http://api.wisercam.com/shop/order/coupon/apply/
export const discount = (token, value) => {
  const url = `${SERVER_URL}/shop/order/coupon/apply/`;
  return axios.post(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/accounts/user_role/
export const getRoleList = (token) => {
  const url = `${SERVER_URL}/accounts/user_role/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/ticket/ticket/
export const getTicket = (token) => {
  const url = `${SERVER_URL}/ticket/ticket/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// @desc  Create New ticket
// @route POST http://94.183.187.36:8000/ticket/ticket/

export const createTicket = (value, token) => {
  const url = `${SERVER_URL}/ticket/ticket/`;
  return axios.post(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/ticket/ticket/:id/close/
export const closeTicket = (token, id) => {
  const url = `${SERVER_URL}/ticket/ticket/${id}/close/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/ticket/ticket/id/
export const getDetailsTicket = (token, id) => {
  const url = `${SERVER_URL}/ticket/ticket/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://94.183.187.36:8000/ticket/id/create/message/
export const answeredTicket = (value, token, id) => {
  const url = `${SERVER_URL}/ticket/${id}/create/message/`;
  return axios.post(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/shop/order/
export const getOrder = (token) => {
  const url = `${SERVER_URL}/shop/order/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/shop/service/4983522022/
export const getDetailOrder = (token, id) => {
  const url = `${SERVER_URL}/shop/service/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/shop/service/0081637811/retrieve/editable/
export const getEditOrder = (token, id) => {
  const url = `${SERVER_URL}/shop/service/${id}/retrieve/editable/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/shop/service/create/old_file/id/
export const Reordering = (token, id) => {
  const url = `${SERVER_URL}/shop/service/create/old_file/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route PUT http://94.183.187.36:8000/accounts/change_password/
export const changePassword = (token, value) => {
  const url = `${SERVER_URL}/accounts/change_password/`;
  return axios.put(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/accounts/user/profile/
export const Profile = (token) => {
  const url = `${SERVER_URL}/accounts/user/profile/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route Patch http://94.183.187.36:8000/accounts/user/profile/update/
export const editProfile = (token, value) => {
  const url = `${SERVER_URL}/accounts/user/profile/update/`;
  return axios.patch(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/ticket/notification/list/
export const getNotification = (token) => {
  const url = `${SERVER_URL}/ticket/notification/list/`;
  return axios.get(url, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://api.wisercam.com/shop/service/properties/
export const getproperties = (token) => {
  const url = `${SERVER_URL}/shop/service/properties/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://api.wisercam.com/shop/order/id/invoice/
export const getFactor = (token, id) => {
  const url = `${SERVER_URL}/shop/order/${id}/invoice/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// get sysadmin address

export const sysAdminAddress = (token) => {
  const url = `${SERVER_URL}/accounts/get_sysadmin_address/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// get sysadmin address

export const sysAdminData = (token) => {
  const url = `${SERVER_URL}/accounts/get_sysadmin_company/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://94.183.187.36:8000/shop/order/
export const createOrder = (value, token) => {
  const url = `${SERVER_URL}/shop/order/`;
  return axios.post(url, value, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getPaymentType = (value, token) => {
  const url = `${SERVER_URL}/payment/get_instalment_detail/`;
  return axios.post(url, value, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/materials/123/
export const getSingleMaterial = (token, id) => {
  const url = `${SERVER_URL}/shop/material/retrieve/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/materials/?q=463
export const searchMaterials = (token, search, category, availableMaterial) => {
  const url = `${SERVER_URL}/shop/material_list/?page=1&page_size=20&search=${search}&persian_group=${category}&available-material=${availableMaterial}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAvailableMaterials = (token, category, availableMaterial) => {
  const url = `${SERVER_URL}/shop/material_list/?page=1&page_size=20&persian_group=${category}&available-material=${availableMaterial}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/materials/?page=463
export const getAllMaterials = (
  token,
  page,
  search,
  category,
  availableMaterial
) => {
  const url = `${SERVER_URL}/shop/material_list/?page=${page}&page_size=20&search=${search}&persian_group=${category}&available-material=${availableMaterial}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://192.168.1.21:8000/shop/service/materials/groups/
export const getMaterialPersianGroups = (token) => {
  const url = `${SERVER_URL}/shop/service/materials/groups/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route PUT http://94.183.187.36:8000/shop/service/upload/mapfile/
export const putTwoDimensionalMap = (token, value) => {
  const url = `${SERVER_URL}/shop/service/upload/mapfile/`;
  return axios.put(url, value, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route PATCH http://94.183.187.36:8000/shop/service/4983522022/
export const updateService = (token, value, id, isSubmit) => {
  const url = `${SERVER_URL}/shop/service/${id}/${
    isSubmit ? "?submit=true" : ""
  }`;
  return axios.patch(url, value, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://api.wisercam.com/shop/service/0150881533/get/image/
// export const getImageService = (token, id) => {
//   const url = `${SERVER_URL}/shop/service/${id}/get/image/`;
//   return axios.get(url, {
//     headers: {
//       "Authorization": `Bearer ${token}`
//     },
//   });
// };

// // @route GET http://94.183.187.36:8000/shop/service/4983522022/
export const getPaymentPageURL = (token, installmentId, orderCode) => {
  const url = `${SERVER_URL}/payment/pay/${installmentId}/${orderCode}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getPaymentCartPageURL = (
  token,
  // installmentId,
  // orderCode,
  // amount
  data
) => {
  const url = `${SERVER_URL}/payment/pay/cart/`;
  return axios.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// export const getPaymentType = (value, token) => {
//   const url = `${SERVER_URL}/payment/get_instalment_detail/`;
//   return axios.post(url, value, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

// // @route GET http://94.183.187.36:8000/payment/transaction/123/check/
export const getPaymentStatus = (token, id) => {
  const url = `${SERVER_URL}/payment/verify/${id}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// // @route GET http://94.183.187.36:8000/payment/transaction/123/check/
export const sendReadService = (token, serviceCode) => {
  const url = `${SERVER_URL}/shop/services/send_read/${serviceCode}/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route GET http://192.168.1.21:8000/shop/province_list/
export const getProvincesList = (token) => {
  const url = `${SERVER_URL}/shop/province_list/`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// @route POST http://94.183.187.36:8000/shop/postprice/
export const postPrice = (value, token) => {
  const url = `${SERVER_URL}/shop/postprice/`;
  return axios.post(url, value, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
